<template>
  <div class="side">
    <template v-if="userInfo">
      <div class="item" :class="{ talk_open: talkShow }" @click="getRoleHandle('L1ExShow-L2IM-L3IM') && talkList()" v-if="isRegOk">
        <i class="icon iconfont icon-ziyuan"></i>
        <div class="txt">咨询记录</div>
        <div class="msg_count" v-if="msgCount">{{ msgCount > 99 ? "99+" : msgCount }}</div>
      </div>
    </template>
    <div class="item" @click="goWebsite()" v-if="exhibitionInfo.website">
      <i class="icon iconfont icon-demo17"></i>
      <div class="txt">展会官网</div>
    </div>
    <div class="item" @click="goCallme()">
      <i class="icon iconfont icon-kefu"></i>
      <div class="txt">联系我们</div>
    </div>
    <Dropdown placement="left" trigger="click" @click.native="tapShare()">
      <div class="item">
        <i class="icon iconfont icon-fenxiang2"></i>
        <div class="txt">分享</div>
      </div>
      <DropdownMenu slot="list">
        <DropdownItem @click.native="share('web')">
          <i class="icon icon-1 iconfont icon-weibo1"></i>
          新浪微博
        </DropdownItem>
        <DropdownItem @click.native="share('qzone')">
          <i class="icon icon-2 iconfont icon-QQkongjian31"></i>
          QQ空间
        </DropdownItem>
        <DropdownItem @click.native="share('qq')">
          <i class="icon icon-3 iconfont icon-qq"></i>
          QQ好友
        </DropdownItem>
        <Poptip trigger="hover" content="content" placement="left-start" width="190">
          <DropdownItem>
            <i class="icon icon-4 iconfont icon-weixin2"></i>
            微信
          </DropdownItem>
          <div slot="content" class="my-show">
            <div id="qrcodeShare" class="qrcode" ref="qrCodeUrl"></div>
            <p
              style="
                text-align: center;
                margin-top:10px;
              "
            >
              用微信扫描二维码
            </p>
          </div>
        </Poptip>
      </DropdownMenu>
    </Dropdown>
    <div class="item" @click="top">
      <i class="icon iconfont icon-top"></i>
      <div class="txt">回到顶部</div>
    </div>
    <div>
      <!-- <shareMobileWx ref="showMobile" v-if="exhibitionId"></shareMobileWx> -->
    </div>
    <talkWrap v-if="talkShow"></talkWrap>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QRCode from "qrcodejs2";
import talkWrap from "../chat-wrap/index.vue";
import url from "@/utils/url";
export default {
  name: "gSide",
  data() {
    return {
      value1: false,
      qrcodUrl: "",
      talkShow: false,
      time: null,
      msgCount: 0,
    };
  },
  components: {
    talkWrap,
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      exhibitionId: "getExhibitionId",
      userInfo: "getUser",
      getShare: "getShare",
    }),
    isRegOk() {
      return this.userInfo && this.userInfo.inMember && this.userInfo.inMember.userRole && this.userInfo.inMember.userRole != "VISITOR" && this.userInfo.inMember.userRole != "Visitor";
    },
    isServer() {
      let ser = false;
      if (this.userInfo && this.userInfo.inMember && this.userInfo.inMember.companyUsers && this.userInfo.inMember.companyUsers.isAppointment) {
        ser = true;
      }
      return ser;
    },
    userMsgQuery() {
      return `
        query{
          agoraQuery{
            userUnreadNumber(exhibitionId:"${this.exhibitionId}",publisherId:"${this.userInfo.userId}")
          }
        }
      `;
    },
    serviceMsgQuery() {
      return `
        query{
          agoraQuery{
            exhibitorUnreadNumber(exhibitorId:"${this.userInfo.inMember.exhibitorId}",publisherId:"${this.userInfo.inMember.companyUsers.id}")
          }
        }
      `;
    },
  },
  created() { 
    if (this.getShare.title) {
      // 没有分享配置
      let share = {
        url: location.href,
        title: this.exhibitionInfo.name,
        desc: this.exhibitionInfo.name,
        summary: this.exhibitionInfo.remark,
        pics: this.exhibitionInfo.logo,
      };
      this.$store.commit("setShare", share);
    }
    if (this.isRegOk) {
      this.goInit();
    }
  },
  mounted() {
    this.$Bus.$off("talkClose");
    this.$Bus.$on("talkClose", () => {
      this.talkShow = false;
    });
  },
  beforeDestroy() {
    if (this.time) {
      clearInterval(this.time);
      this.time = null;
    }
  },
  methods: {
    ...mapActions({
      unverifiedDialog: "unverifiedDialog",
      graphqlPostByZXS: "graphqlPostByZXS",
    }),
    top() {
      // var timer = setInterval(function () {
      //   let osTop =
      //     document.documentElement.scrollTop || document.body.scrollTop;
      //   let ispeed = Math.floor(-osTop / 5);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     osTop + ispeed;
      //   this.isTop = true;
      //   if (osTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 30);
      $("html , body").animate({ scrollTop: 0 }, "slow");
    },
    goInit() {
      this.init();
      this.time = setInterval(() => {
        this.init();
      }, 30000);
    },
    async init() {
      let opt = {
        query: this.userMsgQuery,
        variables: {},
      };
      let data = await this.graphqlPostByZXS(opt);
      console.log(data, "datatata用户消息");
      let count = data.data.agoraQuery.userUnreadNumber || 0;
      if (this.isServer) {
        let opt2 = {
          query: this.serviceMsgQuery,
          variables: {},
        };
        let data2 = await this.graphqlPostByZXS(opt2);
        console.log(data2, "data2");
        count += data2.data.agoraQuery.exhibitorUnreadNumber || 0;
      }
      this.msgCount = count;
    },
    goWebsite() {
      if (this.exhibitionInfo && this.exhibitionInfo.website) {
        window.open(this.exhibitionInfo.website);
      }
    },
    goCallme() {
      if (!this.isRegOk) {
        this.unverifiedDialog(this);
        return;
      }
      this.$router.push(`/user/customer?exhibitionId=${this.exhibitionId}`);
    },
    getQrCode() { 
      let qrcode = new QRCode("qrcodeShare", {
        width: 130,
        height: 130,
        text: this.qrcodUrl, // 二维码内容
        correctLevel: 3,
      });
    },
    getQueryString(name)
    {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
    tapShare() {
      // 点击分享
      if (this.$refs.qrCodeUrl.innerHTML) {
        this.$refs.qrCodeUrl.innerHTML = "";
      }
      let loc_url = location.href;
      let pageType = "";
      let pathname = "";
      if (loc_url.search("/home/index") !== -1) pageType = "home"; // 首页
      if (loc_url.search("/home/demand") !== -1) pageType = "demand"; // 供需
      if (loc_url.search("/home/demandDetail") !== -1) pageType = "demandDetail"; // 供需详情
      if (loc_url.search("/home/exhibitor") !== -1) pageType = "exhibitor"; // 展商列表
      if (loc_url.search("/home/product") !== -1) pageType = "product"; // 展品列表
      if (loc_url.search("/home/activity") !== -1) pageType = "activity"; // 活动列表
      if (loc_url.search("/home/news") !== -1) pageType = "news"; // 资讯列表
      if (loc_url.search("/home/newsDetails") !== -1) pageType = "newsDetails"; // 资讯列表
      if (loc_url.search("/home/about") !== -1) pageType = "about"; // 关于
      if (loc_url.search("/exhibitor-detail") !== -1) pageType = "exhibitor-detail"; // 展商详情
      if (loc_url.search("/product-detail") !== -1) pageType = "product-detail"; // 活动详情
      if (loc_url.search("/activity-details") !== -1) pageType = "activity-details"; // 有直播
      if (loc_url.search("/activity-nolive") !== -1) pageType = "activity-nolive"; // 没直播
      
      let ModelUrl = `https://${url.mobile}`;
      switch (pageType) {
        case "home":
          pathname = `${ModelUrl}/home/${this.exhibitionId}`;
          break;
        case "demand":
          pathname = `${ModelUrl}/headlinesNeeds/${this.exhibitionId}`;
          break;
        case "demandDetail":
          pathname = `${ModelUrl}/needDetails/${this.getQueryString('id')}`;
          break;
        case "exhibitor":
          pathname = `${ModelUrl}/exhibition/${this.exhibitionId}`;
          break;
        case "product":
          pathname = `${ModelUrl}/product/${this.exhibitionId}`;
          break;
        case "activity":
          pathname = `${ModelUrl}/activity/${this.exhibitionId}`;
          break;
        case "news":
          pathname = `${ModelUrl}/news/${this.exhibitionId}`;
          break;
        case "newsDetails":
          pathname = `${ModelUrl}/newsDetails/${this.getQueryString('newId')}`;
          break;
        case "about":
          pathname = `${ModelUrl}/headlinesExinfo/${this.exhibitionId}`;
          break;
        case "exhibitor-detail":
          pathname = `${ModelUrl}/exhibitor/${this.$route.params.id}`;
          break;
        case "product-detail":
          pathname = `${ModelUrl}/product-detail?id=${this.getQueryString('productId')}`;
          break;
        case "activity-details":
          pathname = `${ModelUrl}/live?actId=${this.getQueryString('id')}`;
          break;
        case "activity-nolive":
          pathname = `${ModelUrl}/nolive?actId=${this.getQueryString('id')}`;
          break;
      }
      if (pathname) {
        this.qrcodUrl = pathname;
      } else {
        pathname = `${ModelUrl}/home/${this.exhibitionId}`;
        this.qrcodUrl = pathname;
      }
      console.log(this.qrcodUrl,'ssss')
      this.getQrCode();
    },
    share(type) {
      let title = encodeURIComponent(this.getShare.title);
      let url = encodeURIComponent(location.href);
      let picurl = encodeURIComponent(this.getShare.pics);
      let summary = encodeURIComponent(this.getShare.summary);
      let desc = encodeURIComponent(this.getShare.desc);
      let shareUrl = "";
      switch (type) {
        case "web":
          encodeURIComponent;
          shareUrl = `https://service.weibo.com/share/share.php?url=${url}&title=${title}&&pic=${picurl}&&pic=${picurl}`;
          console.log(shareUrl, "微博分享地址");
          window.open(shareUrl, "newwindow", "height=400,width=600,top=100,left=100");
          break;
        case "qzone":
          shareUrl = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?to=qzone&url=${url}&title=${title}&summary=${summary}`;
          console.log(shareUrl, "qzone分享地址");
          window.open(shareUrl, "newwindow", "height=400,width=600,top=100,left=100");
          break;
        case "qq":
          let share = `https://connect.qq.com/widget/shareqq/index.html?url=${url}&desc=${desc}&summary=&title=${title}&pics=${picurl}`;
          shareUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${url}&desc=${desc}&summary=${summary}&title=${title}&&pics=${picurl}`;
          console.log(shareUrl, "QQ分享地址");
          window.open(share, "newwindow", "height=400,width=600,top=100,left=100");
          break;
        case "wx":
          this.$refs.showMobile.open();
          break;
      }
    },
    talkList() {
      this.$Bus.$emit("talkAloneClose");
      this.talkShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/my-theme/mixin.scss";
::v-deep {
  .ivu-dropdown {
    position: relative;
  }
  .ivu-select-dropdown {
    left: -130px !important;
    top: -4px !important;
  }
  .ivu-back-top {
    bottom: 0 !important;
    right: 0 !important;
    position: relative;
    display: block;
  }
  .ivu-dropdown-item {
    border-bottom: dashed 1px #d9d9d9;
    display: flex;
    align-items: center;
    .icon {
      color: #bfbfbf;
      font-size: 20px;
      margin-right: 8px;
    }
  }
  .ivu-dropdown-item:last-child {
    border: none;
  }
  .ivu-dropdown-item:hover {
    background: #fff;
    .icon-1 {
      color: #e44c3f;
    }
    .icon-2 {
      color: #fab619;
    }
    .icon-3 {
      color: #17abe3;
    }
    .icon-4 {
      color: #49bd38;
    }
  }
  i {
    color: #333;
    padding: 0;
    font-size: 18px;
  }
  .icon-top {
    font-size: 24px;
  }
  .ivu-poptip-body {
    padding: 14px;
    .my-show {
      img {
        margin: 0 auto;
      }
    }
  }
}

.side {
  position: fixed;
  top: 200px;
  right: 20px;
  width: 60px;
  height: 200px;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  z-index: 950;
  font-size: 12px;
  &.tour_wrap {
    top: 50%;
  }
  .item {
    width: 60px;
    height: 60px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    text-align: center;
    align-content: center;
    justify-content: center;
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    color: #333;
    background-color: #fff;
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    &.talk_open {
      @include font_color(#1890ff);
      i {
        @include font_color(#1890ff);
      }
    }
    &:hover {
      color: #fff;
      &.talk_open {
        color: #fff;
        i {
          color: #fff;
        }
      }
      @include background_color(#1890ff);
      i {
        color: #fff;
      }
    }
    .txt {
      width: 100%;
    }
    .msg_count {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #d34242;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -10px;
      top: -10px;
      color: #fff;
    }
  }
}
</style>
